// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605261113/js/" + chunkId + "." + {"44":"e4c3205e","225":"5d4878b8","481":"cae3ebc7","486":"075067d3","770":"82f5655a"}[chunkId] + ".0.7202214618246779.chunk.js";
};